/**
 * Activity Component
 *
 * Features:
 * - Handles the logic for displaying user activity or instructions based on homework status.
 * - Fetches homework and coevaluation data from Redux store.
 * - Passes necessary props to NotActivity for homework status, navigation, and lesson info.
 * - Uses CSS modules for styling and Material-UI for loading state.
 */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getCoevaluationsHomework,
  getHomework,
  getListCoevaluationItems
} from 'store/lesson-actions';

import Loading from 'components/UI/Loading/Loading';
import NotActivity from './NotActivity/NotActivity';
import UserActivity from './UserActivity/UserActivity';

const Activity = props => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    dispatch(getHomework(props.idLesson));
    dispatch(getCoevaluationsHomework(props.idLesson));
    if (!dataLesson.coevaluationsItems) {
      dispatch(getListCoevaluationItems(props.idLesson));
    }
  }, [props.idLesson]);

  useEffect(() => {
    if (dataLesson.homework) {
      setIsLoading(false);
    }
  }, [dataLesson.homework]);

  return (
    <>
      {!isLoading ? (
        <>
          {dataLesson.homework.idUserHomework !== 0 ? (
            <UserActivity />
          ) : (
            /* Props passed to NotActivity:
               - changeHomeworkStatus: props.changeHomeworkStatus (function)
               - returnVideo: props.returnVideo (function)
               - idLesson: props.idLesson (number)
            */
            <NotActivity
              changeHomeworkStatus={props.changeHomeworkStatus}
              returnVideo={props.returnVideo}
              idLesson={props.idLesson}
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

Activity.propTypes = {
  /**
   * Course ID
   */
  idCourse: PropTypes.number,
  /**
   * Lesson ID
   */
  idLesson: PropTypes.number,
  /**
   * Function to return to the video
   */
  returnVideo: PropTypes.func,
  /**
   * Function to change the homework status
   */
  changeHomeworkStatus: PropTypes.func
};

Activity.defaultProps = {
  idCourse: null,
  idLesson: null,
  returnVideo: () => {},
  changeHomeworkStatus: () => {}
};

export default Activity;
